const documents = () => {
    if ($(".documents-list").length) {
        // Toggle filter content when click on title
        $('.filter-item-title').click(function() {
            // Find the closest parent .filter-item then find .filter-item-content within it
            $(this).closest('.filter-item').find('.filter-item-content').slideToggle();
            
            // Rotate arrow icon
            $(this).find('img').toggleClass('rotate-180');
        });

        $('.filter-white').click(function() {
            $('.modal-overlay').addClass('active');
            $('.modal-document').addClass('active');
        });

        $('.icon-close').click(function() {
            $('.modal-overlay').removeClass('active');
            $('.modal-document').removeClass('active');
        });
    }
}

module.exports = documents; 